import { byRelevance } from './byRelevance';
import { bySimstudio } from './bySimstudio';
import { chats } from './chats';
import { documentsIds } from './documentsIds';
import { documentsSimStudioData } from './documentsSimStudioData';
import { generatorsLogs } from './generatorsLogs';
import { kbs } from './kb';
import { kbIds } from './kbIds';
import { ptals } from './ptals';
import { reports } from './reports';
import { reportsCount } from './reportsCount';
import { rtags } from './rtags';
import { signUpAllowed } from './signUpAllowed';
import { signupNotificationEmails } from './signupNotificationEmails';
import { spos } from './spos';
import { taaws } from './taaws';
import { theme } from './theme';
import { users } from './users';
import { usersManage } from './usersManage';

export const API = {
  byRelevance,
  bySimstudio,
  chats,
  generatorsLogs,
  users,
  usersManage,
  spos,
  ptals,
  rtags,
  taaws,
  reports,
  documentsIds,
  reportsCount,
  signUpAllowed,
  signupNotificationEmails,
  kbs,
  kbIds,
  documentsSimStudioData,
  theme,
};
